import validate from "/app/node_modules/.pnpm/nuxt@3.21.9_@types+node@22.19.1_@vue+compiler-sfc@3.5.40_cac@6.7.14_db0@0.3.4_esbuild@0.28.1__umca4ehrwpvw4t32vlxcyqahl4/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/monocle-gallery/middleware/auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.21.9_@types+node@22.19.1_@vue+compiler-sfc@3.5.40_cac@6.7.14_db0@0.3.4_esbuild@0.28.1__umca4ehrwpvw4t32vlxcyqahl4/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "gallery-legacy": () => import("/app/monocle-gallery/middleware/gallery-legacy.ts"),
  loggedin: () => import("/app/monocle-gallery/middleware/loggedin.ts"),
  loggedout: () => import("/app/monocle-gallery/middleware/loggedout.ts"),
  paid: () => import("/app/monocle-gallery/middleware/paid.ts"),
  verified: () => import("/app/monocle-gallery/middleware/verified.ts")
}